import {MessageBox} from 'element-ui'
import router from '@/router'
import {Notification} from 'element-ui'
import YichenLoading from "@/js/utils/Loading";

export default class Tear {


  static toast = (msg) => {
    Notification({
      title: '成功',
      message: msg,
      type: 'success'
    })
  }
  static errToast = (msg) => {
    Notification(
      {
        title: '提示',
        message: msg,
        type: 'error'
      }
    )
  }

  static confirm = ({message, title, showCancelButton = true, confirmButtonText, cancelButtonText}) => {
    return MessageBox.confirm(message || '此操作将永久删除该文件, 是否继续?',
      title || '提示', {
        confirmButtonText: confirmButtonText || '确定',
        cancelButtonText: cancelButtonText || '取消',
        showCancelButton: showCancelButton,
        type: 'warning'
      })
  }

  static showLoading = (text) => {
    // console.log('来了', text)
    YichenLoading.instance.show(text)
  }

  static hideLoading = () => {
    YichenLoading.instance.dismiss()
  }
// -----------------路由控制-----------------------------
  static ROUTER_MAP = {
    PERSONAL_LIST: '/mach/personal',
    STATION_LIST: '/mach/station',
  }
  static to = (path, query) => {
    router.push({path, query: query || {}})
  }

  static back = () => {
    router.go(-1)
  }
}
